export const MaxImportFileSizeBytes = 50 * 1000000;
export function assertImportFileWithinSizeLimit(file) {
    if (file.size > MaxImportFileSizeBytes) {
        throw new Error('Import file is too large');
    }
}
